import { Link } from "react-router-dom";
import { APP_NAVIGATION } from "../../Util/Constants";
import PathHelper from "../../Util/PathHelper";

type Props = {};

const Footer = (props: Props) => {
  const currentYear = new Date().getFullYear();

  const RedirectPrivacyPath = PathHelper(APP_NAVIGATION.PRVCY);
  const RedirectTermsPath = PathHelper(APP_NAVIGATION.TERMS);
  const RedirectContactPath = PathHelper(APP_NAVIGATION.CONPG);

  return (
    <footer id="minimal-footer">
      {/* White container for privacy policy links */}
      <div className="footer-links-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 align-self-center">
              <div className="privacy-policy-parent">
                <Link to={RedirectPrivacyPath.next} target="blank" className="privacy-policy">
                  Privacy Policy
                </Link>
                <div className="div">|</div>
                <Link to={RedirectTermsPath.next} target="blank" className="terms-and-conditions">
                  Terms and Conditions
                </Link>
                <div className="div">|</div>
                <Link to={RedirectContactPath.next} target="blank" className="contact-us">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Blue container for copyright text */}
      <div className="footer-copyright-section">
        <p>
          © {currentYear}, WorkSimpli Software, LLC. a subsidiary of LifeMD Inc., All rights reserved. Proudly
          partnering with{" "}
          <a rel="nofollow noopener noreferrer" href="https://www.solidframework.net/" target="_blank">
            {" "}
            Solid Documents
          </a>{" "}
          and{" "}
          <a rel="nofollow noopener noreferrer" href="https://www.aspose.com" target="_blank">
            Aspose.
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
